export const getTimeDiff = (state) => state.timeDiff;
//# sourceMappingURL=selectors.js.map